'use strict'
module.exports = {
  NODE_ENV: 'production',
  SUB_ENV: 'master',
  VUE_APP_DOC_TITLE_PREFIX: '',
  VUE_APP_MW_DOC: null,
  VUE_APP_DEV_BACKEND_HOST: '',
  VUE_APP_FLOW_ANIMATION: true,
  VUE_APP_FLOW_SHOW_ITEMS: true
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 40